import {AfterViewChecked, Component, ElementRef, HostBinding, Input, OnDestroy, OnInit, Renderer2} from '@angular/core';
import {MatDialog} from '@angular/material';

import {AirComponentType, TemperatureUnit} from '../../../../shared';
import {AirnoteDialogComponent} from '../airnote-dialog/airnote-dialog.component';
import {UtilService} from '../../../../core';
import {Device} from '../../../../afb-api/models/device';
import {Airnote} from '../../../../afb-api/models/airnote';

@Component({
  selector: 'awair-line-tooltip',
  templateUrl: './line-tooltip.component.html',
  styleUrls: ['./line-tooltip.component.scss']
})

export class LineTooltipComponent implements OnInit, AfterViewChecked, OnDestroy {

  @HostBinding('style.position') position = 'absolute';
  @HostBinding('style.visibility') visibility = 'hidden';
  @HostBinding('style.pointer-events') pointerEvents = 'none';

  @Input() temperatureUnit: TemperatureUnit;
  @Input() colorScale: any;
  source: string;
  isPinned: boolean = false;

  get lineTooltipInput(): ILineTooltipInput {
    return this._lineTooltipInput;
  }

  @Input()
  set lineTooltipInput(value: ILineTooltipInput) {
    if (value != null && value.value != null) {
      this.visibility = 'visible';
      this._lineTooltipInput = {...value};
    }
  }
  private _lineTooltipInput: ILineTooltipInput;

  get pinInput(): { pinSource: AirComponentType, isPinned: boolean } {
    return this._pinInput;
  }

  @Input()
  set pinInput(value: { pinSource: AirComponentType, isPinned: boolean }) {
    if (value != null) {
      this.source = value.pinSource;
      this.isPinned = value.isPinned;
    }
  }
  private _pinInput: { pinSource: AirComponentType, isPinned: boolean };



  get airNote(): Airnote {
    return this._airNote;
  }

  @Input()
  set airNote(value: Airnote) {
    this._airNote = value != null ? {...value} : null;
  }
  private _airNote: Airnote;

  constructor(private el: ElementRef,
              private utilService: UtilService,
              private renderer: Renderer2,
              private dialog: MatDialog) {
  }

  ngOnInit() {
  }

  ngAfterViewChecked() {
    // Position after all view things are created
    if (this.lineTooltipInput != null && this.lineTooltipInput.position != null) {
      this.positionTooltip(this.el.nativeElement, this.lineTooltipInput.position);
    }
  }

  ngOnDestroy() {
  }

  removeTooltip(): void {
    this.isPinned = false;
    this.visibility = 'hidden';
  }

  openAirNote(): void {
    let passedColor;
    let passedValue;
    if (this.lineTooltipInput.type === AirComponentType.Temperature && this.temperatureUnit === TemperatureUnit.Fahrenheit) {
      const convertedValue: number = this.utilService.fahrenheitToCelsius(this.lineTooltipInput.value);
      passedValue = convertedValue;
      passedColor = this.colorScale(convertedValue);
    } else {
      passedValue = this.lineTooltipInput.value;
      passedColor = this.colorScale(this.lineTooltipInput.value);
    }

    const dialogRef = this.dialog.open(AirnoteDialogComponent, {disableClose: true});
    dialogRef.componentInstance.date = this.lineTooltipInput.date;
    dialogRef.componentInstance.type = this.lineTooltipInput.type;
    dialogRef.componentInstance.value = passedValue;
    dialogRef.componentInstance.selectedDevice = this.lineTooltipInput.selectedDevice;
    dialogRef.componentInstance.valueColor = passedColor;
    dialogRef.componentInstance.airnote = this.airNote;
    dialogRef.componentInstance.temperatureUnit = this.temperatureUnit;
  }

  private positionTooltip(nativeElement: HTMLElement, position: { x: number, y: number }) {
    const clientRect: ClientRect = nativeElement.getBoundingClientRect();

    // Tooltip's absolute y position - tooltip box height - indicator circle half radius - tooltip bottom arrow size - offset
    this.renderer.setStyle(nativeElement, 'top', (position.y - clientRect.height - 3 - 10 - 3) + 'px');
    this.renderer.setStyle(nativeElement, 'left', (position.x + 4) + 'px');
  }
}

export interface ILineTooltipInput {
  date: Date;
  type: AirComponentType;
  position: { x: number, y: number };
  value: number;
  selectedDevice: Device;
}
